// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { Environment } from '@delon/theme';
export const environment = {
  production: false,
  useHash: true,
  show_login_pwd: {
    show_find_pwd: Boolean,
    show_login: Boolean
  },
  api: {
    // baseUrl: './',
    baseUrl: './service/',
    refreshTokenEnabled: true,
    refreshTokenType: 'auth-refresh',
    // 高德securityJsCode
    securityJsCode: 'f9c591e77f3c850833e05f568062011d',
    // 高德JSAPI key
    JSAPI_key: '577e5c7f66bfa338c18a2b07d4e569bd'
  },
  img: {
    favicon: 'favicon.ico',
    loginlogo: '/assets/loginlogo.png',
    logo_full: '/assets/logo-full.png',
    loginlogo_admin: '/assets/loginlogo-admin.png',
    logo: '/assets/logo.png'
  },
  show986: 0,
  // 患者端 /user/ 远程日志（Fundebug）项目 apikey，需为 64 位字母数字
  fundebug: {
    apikey: 'cb9c3e4c2151b6650b6a9cd7f2a00f44122dfabd6b633dd205bb9d9fee2b25b7',
    // 留空时沿用 SDK 默认上报地址 https://web.fundebug.net/event/；国内站项目如收不到数据，填控制台接入指引里的上报地址
    notifierUrl: ''
  },
  providers: [],
  interceptorFns: [],
  modules: []
} as Environment;

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
